<template>
  <div class="graphics-cont d-flex align-items-center" v-bind:class="{'has-print-color': graphic.manifest.colorFill}">
    <div class="rbi-graphic">
      <a @click="open=true" v-if="!loadingArt">
        <div class="none" v-if="!graphic.image">Add Art</div>
        <div class="graphic" v-if="graphic.image"><img v-bind:src="filepickerUrl"></div>
      </a>

      <div class="spinner" v-if="loadingArt">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>

      <div class="graphic-btn remove" v-if="graphic.image"><a @click="removeGraphic()"><font-awesome-icon icon="times-circle" /></a></div>
      <div class="graphic-btn add" v-if="!graphic.image && !isMobile"><a @click="open=true"><font-awesome-icon icon="plus-circle" /></a></div>

      <!--MODAL-->
      <keep-alive>
        <v-dialog v-model="open" fullscreen hide-overlay transition="dialog-bottom-transition" lazy>
          <v-card class="art-modal">
            <v-toolbar dark color="primary" tabs>
              <v-btn icon dark @click.native="open = false">
                <v-icon>$vuetify.icons.close</v-icon>
              </v-btn>
              <v-toolbar-title>ART - {{ graphic.areaLabel }} {{ graphic.label }}</v-toolbar-title>

              <div class="flex-grow-1"></div>

              <v-toolbar-items>
                <v-btn dark flat @click.native="open = false">Save</v-btn>
              </v-toolbar-items>

              <v-tabs
                slot="extension"
                v-model="tabs"
                centered
                color="primary"
                slider-color="yellow"
              >
                <v-tab>Search</v-tab>
                <v-tab v-if="showCustomUpload">Upload</v-tab>
                <!--<v-tab v-if="isPrinted">QR Code</v-tab>-->
              </v-tabs>

            </v-toolbar>

            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <div class="container mt-4">
                  <div class="row">
                    <div class="col-12">
                      <h5 class="text-dark text-center mb-4">Use Stock Art <span class="text-green">(FREE)!</span></h5>
                    </div>
                  </div>

                  <div v-if="selectedArt.length > 0" class="mb-4">
                    <v-card class="elevation-0">
                      <v-card-title>Currently Selected Art:</v-card-title>
                      <v-card-text>
                        <ul class="selectedArt">
                          <li v-for="clipart in selectedArt">
                            <div class="elevation-1">
                              <img v-bind:src="clipart.image" :alt="clipart.name" @click="selectArt(clipart)">
                            </div>
                          </li>
                        </ul>
                      </v-card-text>
                    </v-card>
                  </div>


                  <div class="row justify-content-center mb-4" v-if="!isPrinted">
                    <div class="col-12 col-md-6">
                      <div class="row">
                        <div class="col-12 col-md-8">
                          <v-text-field
                            label="Search"
                            hint="Ex: heart, ribbon, cross, zebra, etc."
                            persistent-hint
                            v-model="modalTerm"
                            outline
                            @keyup.enter="searchArt()"
                          ></v-text-field>
                        </div>
                        <div class="col-12 col-md-4">
                          <v-btn color="primary" @click="searchArt()">Search</v-btn>
                        </div>
                      </div>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <div class="results border">
                        <ul>
                          <li v-for="clipart in this.art.results">
                            <img v-bind:src="clipart.image" :alt="clipart.name" @click="selectArt(clipart)">
                          </li>
                        </ul>
                        <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading">
                          <span slot="no-results">
                            <p>Sorry, we didn't find anything.<br>Please try another search</p>
                          </span> <span slot="no-more">
                            <p>Sorry, we didn't find any more images</p>
                          </span>
                        </infinite-loading>

                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="container mt-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="text-center mb-4">
                        <v-btn class="text-white lighten-1" color="orange" @click="uploadCustom()">Upload My Own</v-btn>
                      </div>
                      <p class="text-center">Note: We cannot print photos or multi-colored art</p>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item v-if="isPrinted">
                <div class="container mt-4">
                  <div class="row">
                    <div class="col-md-8">
                      <v-text-field
                        label="Data to encode"
                        maxlength="75"
                        counter
                        v-model="modal.qrCode"
                        outline
                        hint="Ex. URL, contact info, phone #, etc."
                        persistent-hint
                        @keyup.enter="makeQRCode()"
                      ></v-text-field>
                    </div>
                    <div class="col-md-4">
                      <v-btn class="text-white lighten-1" color="orange" :loading="loadingQR" :disabled="loadingQR" @click="makeQRCode()">Create</v-btn>
                    </div>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs-items>

          </v-card>
        </v-dialog>
      </keep-alive>
    </div>

    <div class="rbi-graphic-print-color" v-if="graphic.manifest.colorFill && !customband.hasMultipleItems()">
      <colors-select :colors="customband.getPrintColors()" :color-value="graphic.colorFill" :color-required="customband.isPrinted()" :show-label="false" :is-print-color="true" :row-position="0" :single-line="true"></colors-select>
    </div>

<!--                                                           -->
<!--    These buttons are used for debugging the fixed graphics-->
<!--                                                           -->
<!--    <a href="#" class="btn btn-primary" @click="fakeUploadCustom()">Test</a>-->

<!--    <button class="btn btn-danger" @click="removeAreas()">Remove Areas</button>-->

  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import GetCookie from '../utils/getcookie'
  import Filestack from 'filestack-js'
  import _get from 'lodash/get'

  const filestackApiKey = 'FILESTACK-KEY-RETIRED-2026-09'
  const filestackClient = Filestack.init(filestackApiKey)

  let stateName = 'bandbuilder.silicone.graphics'
  let RB = window.RB
  let getCookie = new GetCookie()

  const config = {
    headers: {
      'X-CSRFToken': getCookie.csrf()
    }
  }

  export default {
    props: ['graphic'],
    data () {
      return {
        uuid: this.$uuid.v4(),
        open: false,
        tabs: null,
        loadingArt: false,
        loadingQR: false,
        modal: {
          results: [],
          resultsPage: 1,
          manifestType: '',
          isAutomaticSearch: true,
          qrCode: '',
        },
        isMobile: window.RB.isMobile
      }
    },
    computed: {
      modalTerm: {
        get: function () {
          return this.art.term
        },
        set: function (newValue) {
          this.$store.commit('art/setTerm', newValue)
          this.$store.dispatch('customstates/stepIsDirty', stateName)
        }
      },
      selectedArt () {
        let selectedGraphics = this.customband.getSelectedGraphics()
        return this.customband.getUniqueGraphics(selectedGraphics)
      },
      filepickerUrl () {
        if (this.modal.qrCode) {
          return this.graphic.image
        } else {
          return `https://process.filepicker.io/FILESTACK-KEY-RETIRED-2026-09/output=format:png/${this.graphic.image}`
        }
      },
      isPrinted () {
        return this.customband.isPrinted()
      },
      isWristbandBros () {
        let isBros = false
        if ([70, 71].includes(this.customband.product.id)) {
          isBros = true
        }
        return isBros
      },
      showCustomUpload () {
        let show = true
        if (this.isPrinted && !this.isWristbandBros) {
          show = false
        }
        return show
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'alerts',
        'art'
      ])
    },
    methods: {
      infiniteHandler (state) {
        let data = {
          'term': this.art.term,
          'page': this.modal.resultsPage++,
          'manifestType': this.modal.manifestType,
          'isAutomaticSearch': this.modal.isAutomaticSearch,
          'printStyle': this.customband.getPrintStyleCode(),
        }

        axios.post('/builder/search-clip-art/', data, config).then((resp) => {
          if (resp.data.length) {
            this.modal.results = this.modal.results.concat(resp.data)
            this.$store.commit('art/setResults', this.modal.results)
            state.loaded()
          } else {
            state.complete()
          }
        })
      },
      removeGraphic () {
        this.$store.commit('customband/resetGraphic', this.graphic)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')
        this.$root.$data.fixedPreview.renderAreas()
      },
      searchArt (isAutomaticSearch = null) {
        if (isAutomaticSearch !== null) {
          this.modal.isAutomaticSearch = isAutomaticSearch
        } else {
          this.modal.isAutomaticSearch = false
        }

        this.modal.results = []
        this.$store.commit('art/setResults', [])
        this.modal.resultsPage = 1
        this.$nextTick(() => {
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
        })
        this.$store.dispatch('customstates/stepIsDirty', stateName)
      },
      selectArt (clipart) {
        let isCustom = _get(clipart, 'custom', false)

        // Set custom to false
        let payload = {
          obj: this.graphic,
          custom: isCustom
        }
        this.$store.commit('customband/setGraphicCustom', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)

        if (clipart.is_ex) {
          // Get the new image path
          let imagePath
          let data = {
            'graphic': clipart
          }
          this.loadingArt = true
          let self = this
          axios.post('/builder/gca/', data, config).then((resp) => {
            imagePath = resp.data.image_path
            this.updateGraphicImage(imagePath)
          }).finally(function () {
            self.loadingArt = false
          })
        } else {
          // Update the graphic's image
          this.updateGraphicImage(clipart.image)
        }

        this.$nextTick(() => {
          this.closeModal()
        })
      },
      updateGraphicImage (value) {
        let payload = {
          obj: this.graphic,
          image: value
        }
        this.$store.commit('customband/setGraphicImage', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')

        this.cacheBBImage()
      },
      updateGraphicCustom (isCustom) {
        let payload = {
          obj: this.graphic,
          custom: isCustom
        }
        this.$store.commit('customband/setGraphicCustom', payload)
        this.$store.dispatch('customstates/stepIsDirty', stateName)
        this.$store.dispatch('customband/checkCompletion')

        this.cacheBBImage()
      },
      cacheBBImage () {
        // Cache the SVG so we can use it inside the Bandbuilder without having to retrieve it again
        // console.log('this.graphic.custom', this.graphic.custom)
        let bbImage = this.graphic.custom ? RB.custom_picture : this.graphic.image
        // console.log('bbImage', bbImage)
        if (bbImage) {
          let localImage = sessionStorage.getItem(bbImage)
          if (!localImage) {
            axios.post('/builder/get-svg/', { svgUrl: bbImage }, config).then((resp) => {
              // console.log('resp', resp)
              // console.log('Setting graphic:', this.graphic.image)
              window.sessionStorage.setItem(bbImage, resp.data.svg)

              this.$root.$data.fixedPreview.renderAreas()
            })
          } else {
            this.$root.$data.fixedPreview.renderAreas()
          }
        } else {
          console.error('No Image to cache!')
          console.trace()
        }
      },
      uploadCustom () {
        let pickerOptions = {
          maxSize: 2 * 1024 * 1024,
          accept: ['.jpg', '.jpeg', '.ai', '.eps', '.pdf', '.png', '.svg'],
          fromSources: ['local_file_system', 'url', 'googledrive', 'dropbox', 'box', 'gmail']
        }

        filestackClient.pick(
          pickerOptions,
          function (Blob) {

          }
        ).then((res) => {
          let file = res.filesUploaded[0]
          this.removeGraphic()
          // console.log('file.url', file.url)
          this.updateGraphicImage(file.url)
          this.updateGraphicCustom(true)

          // Close
          this.closeModal()
        })
      },
      closeModal () {
        this.open = false
      },
      fakeUploadCustom () {
        let fileURL = 'https://cdn.filestackcontent.com/G7PtAujFSYuQ76asKdZr'
        this.removeGraphic()
        this.updateGraphicImage(fileURL)
        this.updateGraphicCustom(true)
      },
      removeAreas () {
        this.$root.$data.fixedPreview.removeElements('.area')
        let children = this.$root.$data.fixedPreview.draw.children()
        console.log('children', children)
      },
      makeQRCode () {
        let postData = {
          'data': this.modal.qrCode
        }
        this.loadingQR = true
        axios.post('/builder/qr-code', postData, config).then(resp => {
          // console.log('resp', resp)
          if (resp.data.status === 'success') {
            let url = resp.data.url
            // console.log('url', url)

            // Reset the graphic to null
            this.$store.commit('customband/resetGraphic', this.graphic)

            // Set custom to false
            let payload = {
              obj: this.graphic,
              custom: false
            }
            this.$store.commit('customband/setGraphicCustom', payload)
            this.$store.dispatch('customstates/stepIsDirty', stateName)

            this.updateGraphicImage(url)

            // Close
            this.closeModal()
          }
        }).finally(() => {
          this.loadingQR = false
        })
      }
    },
    created () {
      // console.log('this.graphic', this.graphic)
      // console.log('this.customband.getPrintColors()', this.customband.getPrintColors())
    }
  }
</script>
